__turbopack_context__.v({
  "frequently-bought-together-products": "_1tmr-q_frequently-bought-together-products",
  "heading-container": "_1tmr-q_heading-container",
  "product-checkbox": "_1tmr-q_product-checkbox",
  "product-icon-between-products": "_1tmr-q_product-icon-between-products",
  "product-item": "_1tmr-q_product-item",
  "products-list": "_1tmr-q_products-list",
  "products-total": "_1tmr-q_products-total",
  "products-total-container": "_1tmr-q_products-total-container",
  "products-total-price": "_1tmr-q_products-total-price",
  "products-total-price-actions": "_1tmr-q_products-total-price-actions",
  "products-total-price-actions-shopping-cart": "_1tmr-q_products-total-price-actions-shopping-cart",
  "products-total-price-actions-wishlist": "_1tmr-q_products-total-price-actions-wishlist",
  "products-total-price-description": "_1tmr-q_products-total-price-description",
  "products-total-price-title": "_1tmr-q_products-total-price-title",
  "title": "_1tmr-q_title",
});
